import { useTheme } from '@mui/material';

export const IntroIcon2 = ({ className }: { className: string }) => {
    const theme = useTheme();
    const {
        stroke: { primary: primaryStroke },
        background: { primary: primaryBackground },
    } = theme.colors.other.icon;

    return (
        <svg
            className={className}
            width="40"
            height="40"
            viewBox="0 0 40 40"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M21.3272 10.4638C20.7043 10.2406 20.0232 10.2406 19.4003 10.4638L4.54486 16.07C3.70363 16.3714 3.70363 17.5611 4.54486 17.8625L12.1863 20.5644V28.558C12.1863 29.3758 12.6842 30.1112 13.4435 30.4149L21.4435 33.6149C21.9203 33.8057 22.4522 33.8057 22.9291 33.6149L30.9291 30.4149C31.6884 30.1112 32.1863 29.3758 32.1863 28.558V19.9827L38.1827 17.8625C39.0239 17.5611 39.0239 16.3714 38.1827 16.07L21.3272 10.4638ZM20.4003 23.4687C21.0232 23.6919 21.7043 23.6919 22.3272 23.4687L32.1863 19.9827L22.3272 23.4687C21.7043 23.6919 21.0232 23.6919 20.4004 23.4687L20.4003 23.4687Z"
                fill={primaryBackground}
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M20.203 8.62165L35.6512 14.0819L20.203 19.5422C19.8689 19.6619 19.5036 19.6619 19.1696 19.5422L3.72135 14.0819L19.1696 8.62165C19.5036 8.50195 19.8689 8.50195 20.203 8.62165ZM18.6529 7.17955C19.321 6.94015 20.0516 6.94015 20.7197 7.17955L37.5095 13.1205C38.4119 13.4439 38.4119 14.72 37.5095 15.0433L37.1863 15.1577V25.7815C37.1863 26.2045 36.8434 26.5475 36.4203 26.5475C35.9973 26.5475 35.6544 26.2045 35.6544 25.7815V15.6997L29.4628 17.8906V25.8432C29.4628 26.953 28.8092 27.9588 27.795 28.4095L20.6463 31.5868C19.9201 31.9095 19.0912 31.9095 18.365 31.5868L11.2163 28.4095C10.2021 27.9588 9.54847 26.953 9.54847 25.8432V17.7628L1.86305 15.0433C0.960689 14.72 0.960687 13.4439 1.86305 13.1205L18.6529 7.17955ZM20.7197 20.9843L27.931 18.4326V25.8432C27.931 26.3476 27.6339 26.8048 27.1729 27.0097L20.2716 30.0769V24.1704C20.2716 23.7474 19.9287 23.4045 19.5057 23.4045C19.0827 23.4045 18.7397 23.7474 18.7397 24.1704V30.0769L11.8384 27.0097C11.3774 26.8048 11.0803 26.3476 11.0803 25.8432V18.3048L18.6529 20.9843C19.321 21.2237 20.0516 21.2237 20.7197 20.9843Z"
                fill={primaryStroke}
            />
        </svg>
    );
};
